module.exports = __webpack_public_path__ + "static/cube16-a293ab8a785c9898eea139c84537f1a7.svg";